module.exports = __webpack_public_path__ + "static/scale-model-of-venice-sign-in-los-angeles-california-cd7da0961cb3065085717b0f81c1ac6b.png";